module.exports = __webpack_public_path__ + "img/1bcb483.png";